module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre8",
    attrs: {
      "id": "pgepubid00020"
    }
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1 calibre16 pcalibre2",
    attrs: {
      "id": "The_Lambikin"
    }
  }), _vm._v("The Lambikin")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Once upon a time there was a wee wee Lambikin, who frolicked about on his little tottery legs, and enjoyed himself amazingly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Now one day he set off to visit his Granny, and was jumping with joy to think of all the good things he should get from her, when who should he meet but a Jackal, who looked at the tender young morsel and said: \"Lambikin! Lambikin! I'll "), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("eat")]), _vm._v(" YOU!\"")]), _vm._v(" "), _c('div', {
    staticClass: "figright"
  }, [_c('img', {
    staticClass: "calibre7",
    attrs: {
      "alt": "",
      "src": "Images/img0043.jpg",
      "title": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("But Lambikin only gave a little frisk and said:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"To Granny's house I go,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Where I shall fatter grow,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Then you can eat me so.\""), _c('br', {
    staticClass: "calibre17"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("The Jackal thought this reasonable, and let Lambikin pass.")]), _vm._v(" "), _c('div', {
    staticClass: "figleft1"
  }, [_c('img', {
    staticClass: "calibre7",
    attrs: {
      "alt": "",
      "src": "Images/img0044.jpg",
      "title": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("By-and-by he met a Vulture, and the Vulture, looking hungrily at the tender morsel before him, said: \"Lambikin! Lambikin! I'll "), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("eat")]), _vm._v(" YOU!\""), _c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "id": "Page_18",
      "title": "[18]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("But Lambikin only gave a little frisk, and said:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"To Granny's house I go,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Where I shall fatter grow,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Then you can eat me so.\""), _c('br', {
    staticClass: "calibre17"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("The Vulture thought this reasonable, and let Lambikin pass.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("And by-and-by he met a Tiger, and then a Wolf, and a Dog, and an Eagle, and all these, when they saw the tender little morsel, said: \"Lambikin! Lambikin! I'll "), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("eat")]), _vm._v(" YOU!\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("But to all of them Lambikin replied, with a little frisk:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"To Granny's house I go,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Where I shall fatter grow,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Then you can eat me so.\""), _c('br', {
    staticClass: "calibre17"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("At last he reached his Granny's house, and said, all in a great hurry, \"Granny, dear, I've promised to get very fat; so, as people ought to keep their promises, please put me into the corn-bin "), _c('i', {
    staticClass: "calibre12"
  }, [_vm._v("at once")]), _vm._v(".\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("So his Granny said he was a good boy, and put him into the corn-bin, and there the greedy little Lambikin stayed for seven days, and ate, and ate, and ate, until he could scarcely waddle, and his Granny said he was fat enough for anything, and must go home. But cunning little Lambikin said that would never do, for some animal would be sure to eat him on the way back, he was so plump and tender.")]), _vm._v(" "), _c('div', {
    staticClass: "figleft1"
  }, [_c('img', {
    staticClass: "calibre7",
    attrs: {
      "alt": "",
      "src": "Images/img0045.jpg",
      "title": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("\"I'll tell you what you must do,\" said Master Lambikin, \"you must make a little drumikin out of the skin of my little brother who died, and then I can sit inside and trundle along nicely, for I'm as tight as a drum myself.\""), _c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "id": "Page_19",
      "title": "[19]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("So his Granny made a nice little drumikin out of his brother's skin, with the wool inside, and Lambikin curled himself up snug and warm in the middle, and trundled away gaily. Soon he met with the Eagle, who called out:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"Drumikin! Drumikin!"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Have you seen Lambikin?\""), _c('br', {
    staticClass: "calibre17"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("And Mr. Lambikin, curled up in his soft warm nest, replied:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"Fallen into the fire, and so will you"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("On little Drumikin. Tum-pa, tum-too!\""), _c('br', {
    staticClass: "calibre17"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("\"How very annoying!\" sighed the Eagle, thinking regretfully of the tender morsel he had let slip.")]), _vm._v(" "), _c('div', {
    staticClass: "figright"
  }, [_c('img', {
    staticClass: "calibre7",
    attrs: {
      "alt": "",
      "src": "Images/img0046.jpg",
      "title": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Meanwhile Lambikin trundled along, laughing to himself, and singing:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"Tum-pa, tum-too;"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Tum-pa, tum-too!\""), _c('br', {
    staticClass: "calibre17"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Every animal and bird he met asked him the same question:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"Drumikin! Drumikin!"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Have you seen Lambikin?\""), _c('br', {
    staticClass: "calibre17"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("And to each of them the little slyboots replied:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"Fallen into the fire, and so will you"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("On little Drumikin. Tum-pa, tum too;"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Tum-pa, tum-too; Tum-pa, tum-too!\""), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "id": "Page_20",
      "title": "[20]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Then they all sighed to think of the tender little morsel they had let slip.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("At last the Jackal came limping along, for all his sorry looks as sharp as a needle, and he too called out—")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"Drumikin! Drumikin!"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Have you seen Lambikin?\""), _c('br', {
    staticClass: "calibre17"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("And Lambikin, curled up in his snug little nest, replied gaily:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"Fallen into the fire, and so will you"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("On little Drumikin! Tum-pa——\""), _c('br', {
    staticClass: "calibre17"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("But he never got any further, for the Jackal recognised his voice at once, and cried: \"Hullo! you've turned yourself inside out, have you? Just you come out of that!\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Whereupon he tore open Drumikin and gobbled up Lambikin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "id": "Page_21",
      "title": "[21]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter"
  }, [_c('img', {
    staticClass: "calibre7",
    attrs: {
      "alt": "",
      "src": "Images/img0047.jpg",
      "title": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c71e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0006.vue
// module id = 72
// module chunks = 0